import { render } from "./SeleccionEmpresa.vue?vue&type=template&id=398e4c6c&scoped=true"
import script from "./SeleccionEmpresa.vue?vue&type=script&lang=js"
export * from "./SeleccionEmpresa.vue?vue&type=script&lang=js"

import "./SeleccionEmpresa.vue?vue&type=style&index=0&id=398e4c6c&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-398e4c6c"]])

export default __exports__